import React from 'react';
import PropTypes from 'prop-types';
import Check from '@material-ui/icons/Check';
import classNames from 'classnames';
import { Card } from 'core/components/card';
import { Label } from 'core/components/label';
import useStyles from './quote-checklist.styles';
const QuoteChecklist = ({ items }) => {
  const classes = useStyles();
  const remaining = items.filter((item) => !item.complete).length;
  return (
    <Card className={classes.card}>
      <div className={classes.header}>
        <Label type="body1" component="h2" className={classes.heading}>
          Before purchase
        </Label>
        <Label type="body2">{remaining ? `${remaining} left` : 'Checks complete'}</Label>
      </div>
      <ul className={classes.list}>
        {items.map((item) => (
          <li className={classes.row} key={item.key}>
            <span
              className={classNames(classes.status, { [classes.complete]: item.complete })}
              aria-label={item.complete ? 'Complete' : 'Needs attention'}
            >
              {item.complete && <Check fontSize="small" />}
            </span>
            <div>
              <Label type="body1" className={classes.label}>
                {item.label}
              </Label>
              {!item.complete && (
                <Label type="body2" className={classes.hint}>
                  {item.hint}
                </Label>
              )}
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
};
QuoteChecklist.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      complete: PropTypes.bool.isRequired,
      hint: PropTypes.string
    })
  ).isRequired
};
export default QuoteChecklist;
